import { makeStyles } from '@mui/styles';

export const useStyle = makeStyles((theme) => ({
  paperStyle: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(2),
    gap: theme.spacing(2),
    overflow: 'hidden'
  }
}));
